import React from 'react';
import { Chip } from '@mui/material';
import { TVendorStatus } from '../../types/vendor-types';
import { VENDOR_STATUS_CONFIG } from '../../constants/vendorStatus';

interface VendorStatusBadgeProps {
  status: TVendorStatus;
}

const VendorStatusBadge: React.FC<VendorStatusBadgeProps> = ({ status }) => {
  const config = VENDOR_STATUS_CONFIG[status] || VENDOR_STATUS_CONFIG.pending;

  return (
    <Chip
      label={config.label}
      size="small"
      sx={{
        backgroundColor: config.backgroundColor,
        color: config.textColor,
        fontWeight: 500,
        fontSize: '0.75rem',
        height: '24px',
      }}
    />
  );
};

export default VendorStatusBadge;
